import React from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Cookies from 'universal-cookie';
import GlobalTooltip from 'components/GlobalTooltip';
import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';

const docTypeVal = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
const cookie = new Cookies();

function SignatureTemplate({ rowData }) {
  const history = useHistory();
  const { modals, setSelectedItem, isClientFileManager, isLeadFileManager } = useFileManagerContext();

  const { file_type, esignature_status, esignature_request, pk, sk, case_id } = rowData;

  const condition = file_type && (file_type === 'application/pdf' || file_type === docTypeVal);
  const status = esignature_status?.toLowerCase();

  // Check if signature request has expired
  const isExpired = () => {
    if (!esignature_request?.expiry_date_epoch) return false;
    if (status !== 'pending') return false;

    const currentTime = Date.now(); // milliseconds
    const expiryTime = esignature_request.expiry_date_epoch * 1000; // convert seconds to milliseconds
    // Check if current time is greater than expiry time (expiry has passed)
    return currentTime > expiryTime;
  };

  const expired = isExpired();

  const redirectFileDetails = () => {
    let data = {};

    const currentUser = cookie.get('userId') || null;
    const obj = {
      case_id: case_id,
      file_pk: pk,
      file_sk: sk,
      data: {},
      is_lead: isLeadFileManager,
    };

    data.file_pk = pk;
    data.file_sk = sk;
    data.user_id = currentUser;

    history.push({
      pathname: '/sign-document',
      state: obj,
    });
  };

  const renderStatusContent = () => {
    if (status === 'pending') {
      return (
        <span className="d-inline-flex align-items-center gap-2">
          <span className="d-inline-flex align-items-center gap-1 sign-waiting">
            <i className="pi pi-info-circle info-style me-1" />
            {expired ? 'Expired' : 'Pending'}
          </span>

          {isClientFileManager && !expired && (
            <div
              className="cursor-pointer p-button-secondary ms-2 d-inline-flex align-items-center gap-1"
              onClick={() => redirectFileDetails()}
            >
              <i className="icon-signature" />
              <span className="text-white">Sign</span>
            </div>
          )}
        </span>
      );
    }

    if (status === 'signed') {
      return (
        <span className="d-inline-flex align-items-center gap-1 signed-file">
          <i className="fas fa-check text-success" />
          Signed
        </span>
      );
    }

    return '';
  };

  return (
    <>
      <span className="p-column-title text-break">Signature</span>
      {condition ? (
        isClientFileManager ? (
          <span className="text-break">{renderStatusContent()}</span>
        ) : (
          <>
            <div
              className="signature-icon-container pointer d-inline-block me-2"
              onClick={() => {
                setSelectedItem(rowData);
                modals.setShowSignatureModal(true);
              }}
            >
              <i className="icon-signature" />
            </div>

            <GlobalTooltip tooltip={expired ? 'Signature Request Expired' : esignature_status}>
              <i
                className="fas fa-circle signature-target-icon capitalize cursor-pointer"
                data-pr-tooltip={expired ? 'Signature Request Expired' : esignature_status}
                style={{ color: expired ? 'red' : status === 'pending' ? 'yellow' : status === 'signed' ? 'green' : 'transparent' }}
                onClick={() => {
                  setSelectedItem(rowData);
                  modals.setEsignStatusModal(!modals.showEsignStatusModal);
                }}
              />
            </GlobalTooltip>

            <span className="ms-2">{renderStatusContent()}</span>
          </>
        )
      ) : (
        <span>-</span>
      )}
    </>
  );
}

export default SignatureTemplate;
